import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRequestModelFA } from 'src/app/shared/models/Auth';
import { BidDataRequestDTO } from 'src/app/shared/models/BidDataRequestDTO';
import { FlightDataInputParameter } from 'src/app/shared/models/FlightDataInputParameter';
import { OffLineEvents } from 'src/app/shared/models/LogDetails';
import { INI } from 'src/app/shared/models/WbidINI';
import { WbidApiService } from 'src/app/shared/services/wbid-api.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private ApiService: WbidApiService) { }
  public GetCurrentUserINI(empnum: string): Observable<INI> {
    try {
      return this.ApiService.GetRestDataForGet(
        'INI/GetINIDataForUser?empNum=' + empnum
      );
    } catch (error) {
      return undefined;
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetCrewbidBidDataFiles  ${error.stack.toString()}`
      // );
    }
  }

  public GetHistoryBidData() {
    try {
      return this.ApiService.GetRestDataForGet(
        'BidData/GetAvailableHistoricalList'
      );
    } catch (error) {
      return undefined;
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetCrewbidBidDataFiles  ${error.stack.toString()}`
      // );
    }
  }

  public GetFAListData() {
    try {
      return this.ApiService.GetRestDataForGet(
        "BidData/GetFAList"
      );
    } catch (error) {
      return undefined;
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetCrewbidBidDataFiles  ${error.stack.toString()}`
      // );
    }
  }

  
  public GetLatestNewsFile() {
    try {
      return this.ApiService.GetRestDataForGet(
        "BidData/GetLatestNewsPdfFile"
      );
    } catch (error) {
      return undefined;
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetCrewbidBidDataFiles  ${error.stack.toString()}`
      // );
    }
  }

  public GetUsersBidDataList(empnum) {
    try {
      return this.ApiService.GetRestDataForGet(
        "BidData/GetUsersBidDataList?EmpNum=" + empnum
      );
    } catch (error) {
      return undefined;
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetCrewbidBidDataFiles  ${error.stack.toString()}`
      // );
    }
  }
  public GetLastUpdatedTimeOftheINI(empNum) {
    try {
      return this.ApiService.GetRestDataForGet(
        "INI/GetLastUpdatedTimeOftheINI?empNum=" + empNum
      );
    } catch (error) {
      return undefined;
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetCrewbidBidDataFiles  ${error.stack.toString()}`
      // );
    }
  }

  // public GetMonthlyBidFile(BidDataRequest: BidDataRequestDTO) {
  //   try {
  //     return this.ApiService.GetRestDataForPost(
  //       "BidData/GetMonthlyBidFiles/",
  //       BidDataRequest
  //     );
  //   } catch (error) {
  //     // this.crashMail.sendCrashMail(
  //     //   `Function Name: GetMonthlyBidFile  ${error.stack.toString()}`
  //     // );
  //   }
  // }
    public GetMonthlyBidFile(BidDataRequest: BidDataRequestDTO) {
    try {
    return this.ApiService.GetRestDataForPostWithProgress(
        "BidData/GetMonthlyBidFiles/",
        BidDataRequest
      );
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetMonthlyBidFile  ${error.stack.toString()}`
      // );
    }
  }

  public GetJsonFlightData(flightDataInput: FlightDataInputParameter) {
    try {
      return this.ApiService.GetRestDataForPost(
        "BidData/GetJsonFlightData",
        flightDataInput
      );
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetMonthlyBidFile  ${error.stack.toString()}`
      // );
    }
  }
  public SaveINIDataToServer(data) {
    try {
      return this.ApiService.GetRestDataForPost(
        "INI/SaveINIDataToServer", data
      );
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetMonthlyBidFile  ${error.stack.toString()}`
      // );
    }
  }
  public DeleteUserBidData(deleteList) {
    try {
      return this.ApiService.GetRestDataForPost(
        "BidData/DeleteWbidMultipleUserBidData/", deleteList, 'text'
      );
    } catch (error) {
      // this.crashMail.sendCrashMail(
      //   `Function Name: GetMonthlyBidFile  ${error.stack.toString()}`
      // );
    }
  }
  public 
  
CheckCredential(AuthRequestFAModel: AuthRequestModelFA): Observable<any> {
      try {
        const json = {
          Base: AuthRequestFAModel.Base,
          BidRound: AuthRequestFAModel.BidRound,
          EmployeeNumber: AuthRequestFAModel.EmployeeNumber,
          FromAppNumber: AuthRequestFAModel.FromAppNumber,
          Month: AuthRequestFAModel.Month,
          OperatingSystem: AuthRequestFAModel.OperatingSystem,
          Platform: AuthRequestFAModel.Platform,
          Postion: AuthRequestFAModel.Postion,
          Token: AuthRequestFAModel.Token,
          Version: AuthRequestFAModel.Version,
        };
  
        return this.ApiService.GetRestDataForPost(
          'User/GetTokenUsingWBidAuthenticationDetails/',
          json
        );
      } catch (error) {
        return undefined;
        //TODO
        // this.crashMail.sendCrashMail(
        //   `Function Name: CheckCredential  ${error.stack.toString()}`
        // );
      }
    }
    public GetCoverLetter(PacketId) {
      try {
        return this.ApiService.GetRestDataForGetSWAPdf(
          `if-line-base-auction/bid-round/${PacketId}/cover-letter`
        );
      } catch (error) {
        throw `ClassName:HomeService, FunctionName: GetCoverLetter, ErrorMessage: ${error.stack.toString()}`;
      }
    }
  public getSeniorityList(packetId, page, size) {
  return this.ApiService.GetRestDataForGetSWA(
    `if-line-base-auction/bid-round/${packetId}/seniority?page=${page}&size=${size}`
  );
}

public get2ndRoundSeniorityList(packetId, page, size) {
  return this.ApiService.GetRestDataForGetSWA(
    `if-line-base-auction/bid-round/${packetId}/reserves?page=${page}&size=${size}`
  );
}

}
